import ContactComponents from './Contact.vue';

const contact = {
    install:function(Vue) {
        Vue.component('contact', ContactComponents)
    }
}

export default contact;